/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { IPropertyConverter, JsonValue, TaJson } from "ta-json";

import { InvalidOperationError } from "../errors/invalid-operation-error";
import Link from "../link";
import {
    BooleanMemberConditionResource,
    MemberConditionResource,
    NoAncestorMemberConditionResource,
    RelationMemberConditionResource,
    StringMemberConditionResource,
} from "../models/member-condition-resource";

export class MemberConditionResourceConverter implements IPropertyConverter {
    /**
     * Serializes a MemberConditionResource instance into JSON Value.
     *
     * @param value - A MemberConditionResource instance
     *
     * @returns An JSON Value.
     */
    serialize(value: MemberConditionResource): JsonValue {
        return TaJson.serialize(value) as JsonValue;
    }

    /**
     * Deserializes a JSON Value into a MemberConditionResource instance.
     *
     * @param value - A JSON Value
     *
     * @returns A MemberConditionResource instance.
     */
    deserialize(value: JsonValue): MemberConditionResource {
        if (!value) {
            throw new InvalidOperationError("Can't deserialize falsy value.");
        } else if (typeof value !== "object" || value instanceof Array) {
            throw new InvalidOperationError(
                `Expected a value of type 'object', but value was of type '${typeof value}'.`
            );
        }

        const obj = typeof value === "string" ? JSON.parse(value) : value;

        if (obj.definition) {
            return TaJson.deserialize<NoAncestorMemberConditionResource>(value, NoAncestorMemberConditionResource);
        } else if (typeof obj.value === "string") {
            return TaJson.deserialize<StringMemberConditionResource>(value, StringMemberConditionResource);
        } else if (typeof obj.value === "boolean") {
            return TaJson.deserialize<BooleanMemberConditionResource>(value, BooleanMemberConditionResource);
        } else if (this.isLink(obj.value)) {
            return TaJson.deserialize<RelationMemberConditionResource>(value, RelationMemberConditionResource);
        } else {
            throw new InvalidOperationError("Not a known condition format");
        }
    }

    private isLink(arg: any): arg is Link {
        return arg.href !== undefined;
    }
}
